import classNames from 'classnames';
import { t } from 'ttag';

import { shafaAndroidAppUrl, shafaIOSAppUrl } from '@constants';
import { BannerPlacement } from '@hook/useAnimatedAppsBanner';
import { Image } from '@ui/Image';
import { Link } from '@ui/Link';
import { AnimatedPageBanner } from '@components/AnimatedPageBanner';
import { AppsPromotionQRCode, QRCodePlacement } from '@components/AppsPromotionQRCode';

import image1 from './images/image-1.png';
import image2 from './images/image-2.png';
import googlePlay from './images/googlePlay.png';
import appStore from './images/appStore.png';

import s from './AnimatedAppsPromotionBannerDesktop.sss';

const BANNER_DATA_MAP = {
  [BannerPlacement.Main]: {
    title: () => t`Встановити додаток`,
    description: () => t`Зручніше спілкуватися з продавцями і купувати речі, де б ви не знаходились`,
    preview: {
      src: image1,
      width: '113',
      height: '229',
      position: 'center',
    },
    qrCode: QRCodePlacement.MainPageBanner,
  },
  [BannerPlacement.Category]: {
    title: () => t`Встановіть додаток  – дізнавайтеся про новинки`,
    description: () => t`Повідомимо про новинки у цій категорії`,
    preview: {
      src: image1,
      width: '113',
      height: '229',
      position: 'center',
    },
    qrCode: QRCodePlacement.CategoryPageBanner,
  },
  [BannerPlacement.Profile]: {
    title: () => t`Встановити додаток`,
    description: () => t`Отримуйте миттєві сповіщення про нові речі продавців, на яких підписані`,
    preview: {
      src: image2,
      width: '126',
      height: '196',
      position: 'bottom',
    },
    qrCode: QRCodePlacement.ProfilePageBanner,
  },
};

interface Props {
  className?: string,
  isVisible?: boolean,
  placement: BannerPlacement,
  onClose: () => void,
}

export const AnimatedAppsPromotionBannerDesktop: React.FC<Props> = ({
  className,
  isVisible = true,
  placement,
  onClose,
}) => {
  const {
    title,
    description,
    preview,
    qrCode,
  } = BANNER_DATA_MAP[placement];

  return (
    <AnimatedPageBanner
      rootClassName={className}
      containerClassName={s.banner}
      isVisible={isVisible}
      onClose={onClose}
    >
      <div className={s.contentColumn}>
        <p className={s.title}>
          {title()}
        </p>
        <p className={s.caption}>
          {description()}
        </p>
        <div className={s.download}>
          <AppsPromotionQRCode
            placement={qrCode}
            width="96"
            height="96"
          />
          <ul className={s.storeList}>
            <li className={s.storeItem}>
              <Link
                className={s.storeLink}
                href={shafaAndroidAppUrl}
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={onClose}
              >
                <Image
                  src={googlePlay}
                  width="83"
                  height="24"
                />
              </Link>
            </li>
            <li className={s.storeItem}>
              <Link
                className={s.storeLink}
                href={shafaIOSAppUrl}
                target="_blank"
                rel="noopener noreferrer nofollow"
                onClick={onClose}
              >
                <Image
                  src={appStore}
                  width="83"
                  height="24"
                />
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div
        className={classNames(s.imageColumn, {
          [s.imageColumnPositionBottom]: preview.position === 'bottom',
        })}
      >
        <Image
          src={preview.src}
          width={preview.width}
          height={preview.height}
        />
      </div>
    </AnimatedPageBanner>
  );
};
